import { BrandVoiceType } from '@/types/brand-voice'
import { createQuery } from '../api/query'

export const keyBrandVoices = (arg: string) => [`/brand-voices`, arg]
export const useQueryBrandVoices = createQuery<BrandVoiceType[]>({
    key: keyBrandVoices,
    url: '/brand-voices',
})

export const keyBrandVoice = (arg: string) => [`/brand-voice`, arg]
export const useQueryBrandVoice = createQuery<BrandVoiceType>({
    key: keyBrandVoice,
    url: '/brand-voice',
})
